<template>
	<div class="payment">
  	<span class="overview">訂單明細 ( {{ totalNumOfSelectedProducts }} )</span>
    <div class="desktop-only hidden mt-4">
      <div class="mt-6" v-for="cart in selectedProducts">
        <div class="d-flex align-center py-1">
          <v-avatar size="25" class="mr-2">
            <v-img :src="$HOST_URL + cart.seller.usericon"/>
          </v-avatar>
          <div>{{ cart.seller.nickname }}</div>
        </div>
        <v-divider></v-divider>
        <template v-for="order in cart.orders">
          <v-row class="align-center py-1">
            <v-col class="d-flex align-center">
              <v-img 
                :src="$func.productImagePreview(order.product)" 
                aspect-ratio="1"
                width="50"
                max-width="50"
                class="mr-4 pointer"
                @click="$router.push(`/product/${order.product.id}`)"
              ></v-img>
              <router-link :to="`/product/${order.product.id}`">{{ order.product.title }}</router-link>
            </v-col>
            <v-col cols="3" class="d-flex justify-center align-center">
              <div class="peach"></div>
              {{ order.product.price }}
            </v-col>
          </v-row>
          <v-divider></v-divider>
        </template>
      </div>
    </div>

    <div class="mobile-only tablet-only hidden">
      <v-card class="pa-4 my-4" elevation="1" v-for="cart in selectedProducts">
        <div class="d-flex align-center">
          <v-avatar size="25" class="mr-1">
            <v-img :src="$HOST_URL + cart.seller.usericon"/>
          </v-avatar>
          <div>{{ cart.seller.nickname }}</div>
        </div>
        <v-divider class="mt-1 mb-3"></v-divider>
        <div v-for="(order, i) in cart.orders">
          <router-link :to="`/product/${order.product.id}`" class="pr-6">
            <v-img 
              :src="$func.productImagePreview(order.product)" 
              aspect-ratio="1"
              width="50"
              max-width="50"
              class="mr-3"
            ></v-img>
            {{ order.product.title }}
          </router-link>
          <div class="d-flex align-center justify-end">
            <div class="peach"></div>
            {{ order.product.price }}
          </div>
          <v-divider class="my-3" v-if="cart.orders.length - 1 != i"></v-divider>
        </div>
      </v-card>
    </div>

    <div class="mt-6">
    	<span class="overview">配送方式</span>
    	<v-radio-group v-model="shipping" mandatory row>
	      <v-radio class="mr-8" color="pink" label="全家" value="FAMIC2C"></v-radio>
	      <v-radio class="mr-8" color="pink" label="7-11" value="UNIMARTC2C"></v-radio>
        <v-radio class="mr-8" color="pink" label="萊爾富" value="HILIFEC2C"></v-radio>
	    </v-radio-group>
    </div>

    <v-divider class="mt-4"></v-divider>

    <div class="cart-detail">
      <div class="amount">
        <div>
          <span>商品</span>
          <span class="d-flex align-center">
            {{ selectedPrice }}
          </span>
        </div>
        <div>
          <span>運費</span>
          <span class="d-flex align-center">
            待計算
          </span>
        </div>
        <div class="total">
          <span>合計</span>
          <span class="d-flex align-center">
            <div class="peach"></div>
            {{ selectedPrice }}
          </span>
        </div>
      </div>
      <div class="cart-action">
        <v-btn outlined class="black--text" to="/shoppingcart">上一步</v-btn>
        <v-btn color="black white--text" @click="nextStep">下一步</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  data() {
    return {
      shipping: ''
    }
  },
  created() {
    if(this.totalNumOfSelectedProducts == 0) {
      this.$router.push('/shoppingcart')
    }
    if(this.$store.state.shoppingCart.shipping) {
      this.shipping = this.$store.state.shoppingCart.shipping
    }
  },
	computed: {
    ...mapGetters('shoppingCart', ['totalNumOfSelectedProducts', 'selectedProducts', 'selectedPrice'])
  },
  methods: {
    async nextStep() {
      if(this.shipping != this.$store.state.shoppingCart.shipping) {
        await this.axios.post('/member/checkout/pending', {
          logistics_sub_type: this.shipping
        })
        await this.axios.get('/member/map/clear')
      }
      this.$store.dispatch('shoppingCart/setShipping', this.shipping)
      this.$router.push('/shoppingcart/checkout')
    }
  }
}
</script>

<style lang="scss" scoped>
.payment {
  .v-btn--active::before {
    opacity: 0;
  }
  .v-card {
    font-size: 14px;
  }
}
</style>